import { Injectable } from '@angular/core';
import { switchMap, take } from 'rxjs/operators';
import { Details } from "@details/Interfaces/details";
import { EntityKeyService } from '@feature/pma-entity/services/entity-key.service';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { IMultiDetailsResponse } from "@feature/_app_modules/mojo-details-widget/details-widget.types";
import { BehaviorSubject, tap, map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DebtBalancesDueFacadeService {

    constructor(
        private readonly entityKeyService: EntityKeyService,
        private readonly urlBuilder: UrlBuilderService,
        private readonly http: HttpClient) {

    }
    private balances: BehaviorSubject<Details[] | null> = new BehaviorSubject(null);
    private dateAt: BehaviorSubject<Date | null> = new BehaviorSubject(null);

    setBalances(balances: Details[]) {
        this.balances.next(balances);
    }

    get balances$(): Observable<Details[]> {
        return this.balances.asObservable();
    }

    setDateAt(dateAt: Date) {
        this.dateAt.next(dateAt);
    }

    get dateAt$(): Observable<Date> {
        return this.dateAt.asObservable();
    }

    loadDateAt(): Observable<boolean> {
        const url = this.urlBuilder.getUrl(`ageddebt/getmbeageddebtarrearsdate`);
        return this.http.get<Date>(url)
            .pipe(
                tap(x => this.setDateAt(x)),
                map(x => true)
            );
    }

    loadBalancesDueDetails(): Observable<boolean> {

        const url = this.urlBuilder.getUrl(`details/getmultipledetails`);

        return this.entityKeyService.getEntityKey()
            .pipe(
                switchMap((key) => this.http.post<IMultiDetailsResponse>(url, { EntityViewName: 'MftBalancesDue', OwnerEntityKey: key })),
                tap(x => this.setBalances(x.DetailsList)),
                map(x => true)
            );
    }
}
